
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { Navigation } from './components/feature/Navigation';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Navigation />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
